import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { ExternalLink } from "lucide-react";

const materials = [
  {
    name: "PLA NX2 MATT",
    badge: "Standard",
    description: "Matt-Finish PLA mit hervorragender Druckqualität. Ideal für Prototypen, Designobjekte und Sichteile.",
    properties: ["Matt-Oberfläche", "Hohe Detailgenauigkeit", "Biologisch abbaubar"],
    link: "https://www.extrudr.com/de/produkte/katalog/pla-nx2-matt/",
  },
  {
    name: "PETG",
    badge: "Technisch",
    description: "Robustes und lebensmittelechtes Material für Teile mit Feuchtigkeitskontakt oder erhöhter Festigkeit.",
    properties: ["Lebensmittelecht", "Hohe Festigkeit", "Chemikalienbeständig"],
    link: "https://www.extrudr.com/de/produkte/katalog/petg-transparent/",
  },
  {
    name: "FLEX Medium",
    badge: "Flexibel",
    description: "Elastisches Material mit mittlerer Shore-Härte, ideal für Dichtungen, Griffe, flexible Verbindungsteile.",
    properties: ["Elastisch & biegsam", "Abriebfest", "Stoßdämpfend"],
    link: "https://www.extrudr.com/de/produkte/katalog/flex-medium/",
  },
  {
    name: "DuraPro ABS",
    badge: "Hochleistung",
    description: "Hochleistungs-ABS für anspruchsvolle technische Anwendungen und erhöhte Temperaturanforderungen.",
    properties: ["Temperaturbeständig", "Schlagzäh", "UV-beständig"],
    link: "https://www.extrudr.com/de/produkte/katalog/durapro-abs/",
  },
];

const MaterialsSection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });

  return (
    <section ref={ref}>
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-[#1d1d1f] mb-2">Verfügbare Materialien</h2>
        <p className="text-[#6e6e73] text-[15px]">
          Hochwertige Filamente. Nicht vorrätige Materialien auf Anfrage bestellbar.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {materials.map((material, index) => (
          <motion.div
            key={material.name}
            initial={{ opacity: 0, y: 12 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: index * 0.08 }}
            className="bg-white rounded-3xl p-7 border border-black/5 hover:border-black/10 transition-colors group"
          >
            <div className="flex items-start justify-between mb-4">
              <div>
                <span className="text-[11px] font-medium text-[#6e6e73] uppercase tracking-wider">
                  {material.badge}
                </span>
                <h3 className="text-[18px] font-semibold text-[#1d1d1f] mt-0.5">{material.name}</h3>
              </div>
              <a
                href={material.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1d1d1f]/20 hover:text-[#1d1d1f]/60 transition-colors mt-1"
                aria-label={`Mehr zu ${material.name}`}
              >
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
            <p className="text-[14px] text-[#6e6e73] mb-4 leading-relaxed">{material.description}</p>
            <div className="flex flex-wrap gap-1.5">
              {material.properties.map((p) => (
                <span key={p} className="text-[11px] px-2.5 py-1 rounded-full bg-[#f5f5f7] text-[#6e6e73]">
                  {p}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default MaterialsSection;
